module.exports = __webpack_public_path__ + "media/packs/images/flags/GW-ce5aef56553f4e4f30dffd4502c1b996.png";